<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />
        <tabsComp :tabs="tabs" />
        <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:-35px !important;`">
            <v-row style="margin-top:45px;">
                <v-col cols="12" md="12">
                    <form autocomplete="off">
                        <div class="searchTop" style="margin-inline-end:-20px !important;">
                            <div class="searchBar">
                                <div>
                                    <div>{{ lang.chose_from_list }} {{ lang.start_date }}</div>
                                    <b-form-input class="inborder" type="date" v-model="sdate" style="background:#efefef;" />
                                </div>
                                <div>
                                    <div>{{ lang.chose_from_list }} {{ lang.end_date }}</div>
                                    <b-form-input class="inborder" type="date" v-model="edate" style="background:#efefef;" />
                                </div>
                                <div>
                                    <div>{{ lang.plate_number || 'رقم اللوحة' }}</div>
                                    <b-form-input class="inborder" v-model="plate_number" style="background:#efefef;" />
                                </div>
                                <div>
                                    <div>{{ lang.mobile }}</div>
                                    <b-form-input class="inborder" v-model="mobile" style="background:#efefef;" />
                                </div>
                                <div>
                                    <div>{{ lang.report_number || 'رقم التقرير' }}</div>
                                    <b-form-input class="inborder" v-model="report_number" style="background:#efefef;" />
                                </div>
                                <div>
                                    <div>&nbsp;</div>
                                    <b-button variant="light" style="padding-top:2px !important;padding-bottom:2px !important;background:blue;color:#fff;width:75px;" @click="getReports()">{{ lang.search }}</b-button>
                                </div>
                            </div>
                            <div style="margin-inline-end:17px;">
                                <b-button
                                    @click="addNew()"
                                    v-b-toggle.add_vehicle_inspection
                                    class="btn-sm btn"
                                    style="margin-top:7px;width:180px;background:transparent;border:none !important;margin-left:-7px !important;"
                                    id="multiply-button"
                                >
                                    <div :class="`multiply-button-content-`+lang.lalgin" style="width:180px;border:none !important">{{ lang.add_vehicle_inspection || 'إضافة فحص شامل' }}</div>
                                </b-button>
                            </div>
                        </div>
                    </form>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" :style="`direction:`+lang.dir+`;`">
                    <v-data-table
                        :headers="headers"
                        :items="tablerows"
                        :items-per-page="-1"
                        width="100%"
                        id="MainTable"
                        hide-default-footer
                        fixed-header
                    >
                        <template v-slot:item="row">
                            <tr>
                                <td class="text-center">{{ row.item.report_number }}</td>
                                <td class="text-center">{{ row.item.inspection_date }}</td>
                                <td class="text-center">{{ row.item.customer_name }}</td>
                                <td class="text-center">{{ row.item.customer_mobile }}</td>
                                <td class="text-center">{{ row.item.plate_number }}</td>
                                <td class="text-center">{{ row.item.brand }} {{ row.item.model }}</td>
                                <td class="text-center">{{ ratingLabel(row.item.overall_rating) }}</td>
                                <td class="text-center" :style="row.item.whatsapp_sent_date ? 'color:#0a8a3f;' : 'color:#999;'">{{ row.item.whatsapp_sent_date ? (lang.sent || 'تم الإرسال') : (lang.not_sent || 'لم يُرسل') }}</td>
                                <td
                                    style="cursor:pointer;width:85px;border-top:1px solid #bbb !important;border-bottom:1px solid #bbb !important;"
                                    class="backBlue text-center"
                                    v-b-toggle.add_vehicle_inspection
                                >
                                    <div style="color:#fff !important;" @click="viewReport(row.item.id)">{{ lang.view }}</div>
                                </td>
                                <td
                                    style="cursor:pointer;width:85px;border-top:1px solid #bbb !important;border-bottom:1px solid #bbb !important;"
                                    class="backBlack text-center"
                                >
                                    <div style="color:#fff !important;" @click="printReport(row.item.id)">{{ lang.print }}</div>
                                </td>
                                <td
                                    style="cursor:pointer;width:85px;border-top:1px solid #bbb !important;border-bottom:1px solid #bbb !important;"
                                    class="backRed text-center"
                                >
                                    <div style="color:#fff !important;" @click="deleteReport(row.item.id)">{{ lang.delete }}</div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-row>
        <addVehicleInspectionReport ref="addVehicleInspectionReport" @saved="getReports" />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import ExportsPrint from '@/components/exports-print.vue'
import TabsComp from '@/components/tabsComp.vue'
import addVehicleInspectionReport from '@/components/addVehicleInspectionReport.vue'
import axios from 'axios'
export default {
    components: {
        HeaderPortrate, ExportsPrint, TabsComp, addVehicleInspectionReport,
    },
    data() {
        return {
            sdate: '',
            edate: '',
            plate_number: '',
            mobile: '',
            report_number: '',
            tablerows: [],
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki) == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki) == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        tabs: function(){
            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
                const cM = localStorage.getItem('currentMenu');
                if(value.main.index == cM){
                    cMenu = value.sub;
                }else if(cM == null && value.main.index == 1){
                    cMenu = value.sub;
                }
            });
            let t = []
            Object.values(cMenu).forEach(value =>{
                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                        if(alicense[value.perms[0]] || value.perms[0] == 'any')
                            t.push(value)
                    }
                }
            })
            return t;
        },
        headers: function(){
            return [
                { text: this.lang.report_number || 'رقم التقرير', align: 'center', value: 'report_number', sortable: false, class: 'pa-0 backBlack' },
                { text: this.lang.inspection_date || 'تاريخ الفحص', align: 'center', value: 'inspection_date', sortable: false, class: 'pa-0 backBlack' },
                { text: this.lang.customer_name, align: 'center', value: 'customer_name', sortable: false, class: 'pa-0 backBlack' },
                { text: this.lang.mobile, align: 'center', value: 'customer_mobile', sortable: false, class: 'pa-0 backBlack' },
                { text: this.lang.plate_number || 'رقم اللوحة', align: 'center', value: 'plate_number', sortable: false, class: 'pa-0 backBlack' },
                { text: this.lang.car_model || 'السيارة', align: 'center', value: 'model', sortable: false, class: 'pa-0 backBlack' },
                { text: this.lang.overall_rating || 'التقييم', align: 'center', value: 'overall_rating', sortable: false, class: 'pa-0 backBlack' },
                { text: this.lang.whatsapp || 'واتساب', align: 'center', value: 'whatsapp_sent_date', sortable: false, class: 'pa-0 backBlack' },
                { text: this.lang.view, align: 'center', value: 'agent', sortable: false, class: 'pa-0 backBlue' },
                { text: this.lang.print, align: 'center', value: 'agent', sortable: false, class: 'pa-0 backBlack' },
                { text: this.lang.delete, align: 'center', value: 'agent', sortable: false, class: 'pa-0 backRed' },
            ];
        },
    },
    methods: {
        ratingLabel(val){
            const ar = { excellent: 'ممتاز', very_good: 'جيدة جداً', good: 'جيدة', acceptable: 'مقبولة', needs_major_repair: 'تحتاج إصلاحات كبيرة' };
            const en = { excellent: 'Excellent', very_good: 'Very Good', good: 'Good', acceptable: 'Acceptable', needs_major_repair: 'Needs Major Repair' };
            const dict = this.lang.langname === 'en' ? en : ar;
            return dict[val] || '-';
        },
        async getReports(){
            const post = new FormData();
            post.append('type', 'getVehicleInspectionReports');
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            if(this.sdate) post.append('data[sdate]', this.sdate);
            if(this.edate) post.append('data[edate]', this.edate);
            if(this.plate_number) post.append('data[plate_number]', this.plate_number);
            if(this.mobile) post.append('data[mobile]', this.mobile);
            if(this.report_number) post.append('data[report_number]', this.report_number);
            const response = await axios.post(this.$store.state.SAMCOTEC.r_path, post);
            if(response && response.data && response.data.results){
                this.tablerows = response.data.results.data || [];
            }
        },
        addNew(){
            this.$refs.addVehicleInspectionReport.resetAll();
        },
        viewReport(id){
            this.$refs.addVehicleInspectionReport.loadReport(id);
        },
        printReport(id){
            window.open('../api/print.php?vireport=' + id, '_blank');
        },
        async deleteReport(id){
            if(!window.confirm(this.lang.confirm_delete || 'هل أنت متأكد من الحذف؟')) return;
            const post = new FormData();
            post.append('type', 'deleteVehicleInspectionReport');
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[id]', id);
            await axios.post(this.$store.state.SAMCOTEC.r_path, post);
            this.getReports();
        },
    },
    created(){
        this.getReports();
    }
}
</script>
